import I18n from "i18n-js";
I18n.defaultLocale = "ja";
I18n.locale = "ja";
I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend(I18n.translations["en"] || {}, {
  activity_frequent_name: "頻度",
  activity_term_name: "期間",
  additional_email: "予備のメールアドレス",
  address: "住所",
  adopted: "採用済",
  all_contact_text: "伝達事項・質問",
  apply: "応募",
  area_name: "活動場所",
  area_simple_name: "エリア",
  ask: "お問い合わせ",
  atmosphere_name: "雰囲気",
  birthday: "生年月日",
  chara_simple_name: "特徴",
  characteristic_name: "特徴",
  closing: "募集終了",
  company_site: "連携企業",
  considering: "選考中",
  donate_goods: "物品寄付",
  donate_goods_activity_content_item_name: "活動内容",
  donate_goods_activity_philosophy_item_name: "活動理念",
  donate_goods_apply_link_item_name: "応募方法",
  donate_goods_atmosphere_comment_item_name: "雰囲気",
  donate_goods_atmospheres_item_name: "雰囲気",
  donate_goods_build_year_item_name: "設立年",
  donate_goods_characteristics_item_name: "特徴",
  donate_goods_charitable_gifts_item_name: "物品の種類",
  donate_goods_corporate_status_item_name: "法人格",
  donate_goods_deadline_item_name: "募集締切",
  donate_goods_description_item_name: "説明文",
  donate_goods_detail_info_item_name: "募集詳細",
  donate_goods_facebook_url_item_name: "FacebookページのURL",
  donate_goods_genres_item_name: "活動テーマ",
  donate_goods_get_activity_locations_item_name: "活動場所",
  donate_goods_get_areas_item_name: "活動場所",
  donate_goods_get_dates_or_terms_item_name: "活動日",
  donate_goods_get_frequents_item_name: "活動頻度",
  donate_goods_get_gender_rate_item_name: "男女比",
  donate_goods_get_member_activity_dates_item_name: "活動日",
  donate_goods_get_prices_item_name: "必要経費",
  donate_goods_get_terms_and_frequents_item_name: "所属期間/頻度",
  donate_goods_get_terms_or_periods_item_name: "所属期間",
  donate_goods_get_working_forms_item_name: "勤務形態",
  donate_goods_job_characteristics_item_name: "特徴",
  donate_goods_job_types_item_name: "職種",
  donate_goods_kind_item_name: "種類",
  donate_goods_name_item_name: "団体名",
  donate_goods_number_of_employees_item_name: "職員数",
  donate_goods_participation_comment_item_name: "体験談",
  donate_goods_participation_number_item_name: "募集人数",
  donate_goods_pictures_item_name: "写真",
  donate_goods_positions_item_name: "対象身分/年齢",
  donate_goods_remarkable_points_item_name: "注目ポイント",
  donate_goods_representation_item_name: "代表者",
  donate_goods_service_types_item_name: "提供サービス",
  donate_goods_skills_item_name: "スキル",
  donate_goods_street_address_item_name: "住所",
  donate_goods_tags_item_name: "社会問題",
  donate_goods_target_item_name: "募集対象",
  donate_goods_term_category_item_name: "活動期間",
  donate_goods_title_item_name: "タイトル",
  donate_goods_twitter_account_item_name: "Twitterアカウント",
  donate_goods_universities_item_name: "関連大学",
  donate_goods_url_item_name: "HPのURL",
  donate_goods_working_forms_item_name: "勤務形態",
  draft: "下書き",
  event: "イベント/講演会",
  event_activity_content_item_name: "活動内容",
  event_activity_philosophy_item_name: "活動理念",
  event_apply_link_item_name: "応募方法",
  event_atmosphere_comment_item_name: "雰囲気",
  event_atmospheres_item_name: "雰囲気",
  event_build_year_item_name: "設立年",
  event_characteristics_item_name: "特徴",
  event_charitable_gifts_item_name: "物品の種類",
  event_corporate_status_item_name: "法人格",
  event_deadline_item_name: "募集締切",
  event_description_item_name: "説明文",
  event_detail_info_item_name: "募集詳細",
  event_facebook_url_item_name: "FacebookページのURL",
  event_genres_item_name: "活動テーマ",
  event_get_activity_locations_item_name: "開催場所",
  event_get_areas_item_name: "開催場所",
  event_get_dates_or_terms_item_name: "開催日",
  event_get_frequents_item_name: "開催頻度",
  event_get_gender_rate_item_name: "男女比",
  event_get_member_activity_dates_item_name: "開催日",
  event_get_prices_item_name: "必要経費",
  event_get_terms_and_frequents_item_name: "所属期間/頻度",
  event_get_terms_or_periods_item_name: "活動期間",
  event_get_working_forms_item_name: "勤務形態",
  event_job_characteristics_item_name: "特徴",
  event_job_types_item_name: "職種",
  event_kind_item_name: "種類",
  event_name_item_name: "団体名",
  event_number_of_employees_item_name: "職員数",
  event_participation_comment_item_name: "体験談",
  event_participation_number_item_name: "募集人数",
  event_pictures_item_name: "写真",
  event_positions_item_name: "対象身分/年齢",
  event_remarkable_points_item_name: "注目ポイント",
  event_representation_item_name: "代表者",
  event_service_types_item_name: "提供サービス",
  event_skills_item_name: "スキル",
  event_street_address_item_name: "住所",
  event_tags_item_name: "社会問題",
  event_target_item_name: "募集対象",
  event_term_category_item_name: "開催期間",
  event_title_item_name: "タイトル",
  event_twitter_account_item_name: "Twitterアカウント",
  event_universities_item_name: "関連大学",
  event_url_item_name: "HPのURL",
  event_working_forms_item_name: "勤務形態",
  female: "女性",
  future: "公開予約",
  gender: "性別",
  genre_name: "活動テーマ",
  genre_simple_name: "テーマ",
  holding: "保留中",
  intern: "国内外インターンシップ",
  intern_activity_content_item_name: "活動内容",
  intern_activity_philosophy_item_name: "活動理念",
  intern_apply_link_item_name: "応募方法",
  intern_atmosphere_comment_item_name: "雰囲気",
  intern_atmospheres_item_name: "雰囲気",
  intern_build_year_item_name: "設立年",
  intern_characteristics_item_name: "特徴",
  intern_charitable_gifts_item_name: "物品の種類",
  intern_corporate_status_item_name: "法人格",
  intern_deadline_item_name: "募集締切",
  intern_description_item_name: "説明文",
  intern_detail_info_item_name: "募集詳細",
  intern_facebook_url_item_name: "FacebookページのURL",
  intern_genres_item_name: "活動テーマ",
  intern_get_activity_locations_item_name: "勤務場所",
  intern_get_areas_item_name: "勤務場所",
  intern_get_dates_or_terms_item_name: "勤務日",
  intern_get_frequents_item_name: "勤務頻度",
  intern_get_gender_rate_item_name: "男女比",
  intern_get_member_activity_dates_item_name: "勤務日",
  intern_get_prices_item_name: "待遇",
  intern_get_terms_and_frequents_item_name: "勤務期間/頻度",
  intern_get_terms_or_periods_item_name: "勤務期間",
  intern_get_working_forms_item_name: "勤務形態",
  intern_job_characteristics_item_name: "特徴",
  intern_job_types_item_name: "職種",
  intern_kind_item_name: "種類",
  intern_name_item_name: "団体名",
  intern_number_of_employees_item_name: "職員数",
  intern_participation_comment_item_name: "体験談",
  intern_participation_number_item_name: "募集人数",
  intern_pictures_item_name: "写真",
  intern_positions_item_name: "対象身分/年齢",
  intern_remarkable_points_item_name: "注目ポイント",
  intern_representation_item_name: "代表者",
  intern_service_types_item_name: "提供サービス",
  intern_skills_item_name: "スキル",
  intern_street_address_item_name: "住所",
  intern_tags_item_name: "社会問題",
  intern_target_item_name: "募集対象",
  intern_term_category_item_name: "勤務期間",
  intern_title_item_name: "タイトル",
  intern_twitter_account_item_name: "Twitterアカウント",
  intern_universities_item_name: "関連大学",
  intern_url_item_name: "HPのURL",
  intern_working_forms_item_name: "勤務形態",
  job: "社員/職員/アルバイト",
  job_activity_content_item_name: "活動内容",
  job_activity_philosophy_item_name: "活動理念",
  job_apply_link_item_name: "応募方法",
  job_area_name: "勤務地",
  job_atmosphere_comment_item_name: "雰囲気",
  job_atmospheres_item_name: "雰囲気",
  job_build_year_item_name: "設立年",
  job_chara_simple_name: "特徴",
  job_characteristic_name: "特徴",
  job_characteristics_item_name: "特徴",
  job_charitable_gifts_item_name: "物品の種類",
  job_corporate_status_item_name: "法人格",
  job_deadline_item_name: "募集締切",
  job_description_item_name: "説明文",
  job_detail_info_item_name: "募集詳細",
  job_facebook_url_item_name: "FacebookページのURL",
  job_genre_name: "活動テーマ",
  job_genres_item_name: "活動テーマ",
  job_get_activity_locations_item_name: "勤務場所",
  job_get_areas_item_name: "勤務場所",
  job_get_dates_or_terms_item_name: "勤務日",
  job_get_frequents_item_name: "勤務頻度",
  job_get_gender_rate_item_name: "男女比",
  job_get_member_activity_dates_item_name: "勤務日",
  job_get_prices_item_name: "待遇",
  job_get_terms_and_frequents_item_name: "勤務期間/頻度",
  job_get_terms_or_periods_item_name: "勤務期間",
  job_get_working_forms_item_name: "勤務形態",
  job_job_characteristics_item_name: "特徴",
  job_job_type_name: "職種",
  job_job_types_item_name: "職種",
  job_kind_item_name: "種類",
  job_name_item_name: "団体名",
  job_number_of_employees_item_name: "職員数",
  job_participation_comment_item_name: "体験談",
  job_participation_number_item_name: "募集人数",
  job_pictures_item_name: "写真",
  job_position_name: "対象年齢/身分",
  job_positions_item_name: "対象身分/年齢",
  job_remarkable_points_item_name: "注目ポイント",
  job_representation_item_name: "代表者",
  job_service_type_name: "提供サービス",
  job_service_types_item_name: "提供サービス",
  job_skills_item_name: "スキル",
  job_street_address_item_name: "住所",
  job_tag_name: "社会問題",
  job_tags_item_name: "社会問題",
  job_target_item_name: "募集対象",
  job_term_category_item_name: "勤務期間",
  job_title_item_name: "タイトル",
  job_twitter_account_item_name: "Twitterアカウント",
  job_type_name: "職種",
  job_universities_item_name: "関連大学",
  job_url_item_name: "HPのURL",
  job_working_form_name: "勤務形態",
  job_working_forms_item_name: "勤務形態",
  jt_simple_name: "職種",
  kind_name: "種類",
  kind_simple_name: "種類",
  male: "男性",
  member: "団体メンバー/継続ボランティア",
  member_activity_content_item_name: "活動内容",
  member_activity_philosophy_item_name: "活動理念",
  member_apply_link_item_name: "応募方法",
  member_atmosphere_comment_item_name: "雰囲気",
  member_atmospheres_item_name: "雰囲気",
  member_build_year_item_name: "設立年",
  member_characteristics_item_name: "特徴",
  member_charitable_gifts_item_name: "物品の種類",
  member_corporate_status_item_name: "法人格",
  member_deadline_item_name: "募集締切",
  member_description_item_name: "説明文",
  member_detail_info_item_name: "募集詳細",
  member_facebook_url_item_name: "FacebookページのURL",
  member_genres_item_name: "活動テーマ",
  member_get_activity_locations_item_name: "活動場所",
  member_get_areas_item_name: "活動場所",
  member_get_dates_or_terms_item_name: "活動日",
  member_get_frequents_item_name: "活動頻度",
  member_get_gender_rate_item_name: "男女比",
  member_get_member_activity_dates_item_name: "活動日",
  member_get_prices_item_name: "必要経費",
  member_get_terms_and_frequents_item_name: "所属期間/頻度",
  member_get_terms_or_periods_item_name: "所属期間",
  member_get_working_forms_item_name: "勤務形態",
  member_job_characteristics_item_name: "特徴",
  member_job_types_item_name: "職種",
  member_kind_item_name: "種類",
  member_name_item_name: "団体名",
  member_number_of_employees_item_name: "職員数",
  member_participation_comment_item_name: "体験談",
  member_participation_number_item_name: "募集人数",
  member_pictures_item_name: "写真",
  member_positions_item_name: "対象身分/年齢",
  member_remarkable_points_item_name: "注目ポイント",
  member_representation_item_name: "代表者",
  member_service_types_item_name: "提供サービス",
  member_skills_item_name: "スキル",
  member_street_address_item_name: "住所",
  member_tags_item_name: "社会問題",
  member_target_item_name: "募集対象",
  member_term_category_item_name: "活動期間",
  member_title_item_name: "タイトル",
  member_twitter_account_item_name: "Twitterアカウント",
  member_universities_item_name: "関連大学",
  member_url_item_name: "HPのURL",
  member_working_forms_item_name: "勤務形態",
  no_answer: "回答しない",
  not_set: "未対応",
  organic: "activo",
  overlapping: "重複応募",
  part_timer: "バイト/パート",
  phone_num: "電話番号",
  posi_simple_name: "対象年齢/身分",
  position_name: "対象年齢/身分",
  postal_code: "郵便番号",
  price_category_name: "予算",
  probono: "プロボノ",
  probono_activity_content_item_name: "活動内容",
  probono_activity_philosophy_item_name: "活動理念",
  probono_apply_link_item_name: "応募方法",
  probono_atmosphere_comment_item_name: "雰囲気",
  probono_atmospheres_item_name: "雰囲気",
  probono_build_year_item_name: "設立年",
  probono_characteristics_item_name: "特徴",
  probono_charitable_gifts_item_name: "物品の種類",
  probono_corporate_status_item_name: "法人格",
  probono_deadline_item_name: "募集締切",
  probono_description_item_name: "説明文",
  probono_detail_info_item_name: "募集詳細",
  probono_facebook_url_item_name: "FacebookページのURL",
  probono_genres_item_name: "活動テーマ",
  probono_get_activity_locations_item_name: "活動場所",
  probono_get_areas_item_name: "活動場所",
  probono_get_dates_or_terms_item_name: "活動日",
  probono_get_frequents_item_name: "活動頻度",
  probono_get_gender_rate_item_name: "男女比",
  probono_get_member_activity_dates_item_name: "活動日",
  probono_get_prices_item_name: "必要経費",
  probono_get_terms_and_frequents_item_name: "所属期間/頻度",
  probono_get_terms_or_periods_item_name: "活動期間",
  probono_get_working_forms_item_name: "勤務形態",
  probono_job_characteristics_item_name: "特徴",
  probono_job_types_item_name: "職種",
  probono_kind_item_name: "種類",
  probono_name_item_name: "団体名",
  probono_number_of_employees_item_name: "職員数",
  probono_participation_comment_item_name: "体験談",
  probono_participation_number_item_name: "募集人数",
  probono_pictures_item_name: "写真",
  probono_positions_item_name: "対象身分/年齢",
  probono_remarkable_points_item_name: "注目ポイント",
  probono_representation_item_name: "代表者",
  probono_service_types_item_name: "提供サービス",
  probono_skills_item_name: "スキル",
  probono_street_address_item_name: "住所",
  probono_tags_item_name: "社会問題",
  probono_target_item_name: "募集対象",
  probono_term_category_item_name: "活動期間",
  probono_title_item_name: "タイトル",
  probono_twitter_account_item_name: "Twitterアカウント",
  probono_universities_item_name: "関連大学",
  probono_url_item_name: "HPのURL",
  probono_working_forms_item_name: "勤務形態",
  promotion: "広報力upオプション",
  publish: "募集中",
  regular_employee: "社員/職員",
  rejected: "不採用",
  replied: "返信済み",
  scout: "スカウト",
  search_for_company: "連携企業",
  singly: "国内/単発ボランティア",
  singly_activity_content_item_name: "活動内容",
  singly_activity_philosophy_item_name: "活動理念",
  singly_apply_link_item_name: "応募方法",
  singly_atmosphere_comment_item_name: "雰囲気",
  singly_atmospheres_item_name: "雰囲気",
  singly_build_year_item_name: "設立年",
  singly_characteristics_item_name: "特徴",
  singly_charitable_gifts_item_name: "物品の種類",
  singly_corporate_status_item_name: "法人格",
  singly_deadline_item_name: "募集締切",
  singly_description_item_name: "説明文",
  singly_detail_info_item_name: "募集詳細",
  singly_facebook_url_item_name: "FacebookページのURL",
  singly_genres_item_name: "活動テーマ",
  singly_get_activity_locations_item_name: "活動場所",
  singly_get_areas_item_name: "活動場所",
  singly_get_dates_or_terms_item_name: "活動日",
  singly_get_frequents_item_name: "活動頻度",
  singly_get_gender_rate_item_name: "男女比",
  singly_get_member_activity_dates_item_name: "活動日",
  singly_get_prices_item_name: "必要経費",
  singly_get_terms_and_frequents_item_name: "所属期間/頻度",
  singly_get_terms_or_periods_item_name: "活動期間",
  singly_get_working_forms_item_name: "勤務形態",
  singly_job_characteristics_item_name: "特徴",
  singly_job_types_item_name: "職種",
  singly_kind_item_name: "種類",
  singly_name_item_name: "団体名",
  singly_number_of_employees_item_name: "職員数",
  singly_participation_comment_item_name: "体験談",
  singly_participation_number_item_name: "募集人数",
  singly_pictures_item_name: "写真",
  singly_positions_item_name: "対象身分/年齢",
  singly_remarkable_points_item_name: "注目ポイント",
  singly_representation_item_name: "代表者",
  singly_service_types_item_name: "提供サービス",
  singly_skills_item_name: "スキル",
  singly_street_address_item_name: "住所",
  singly_tags_item_name: "社会問題",
  singly_target_item_name: "募集対象",
  singly_term_category_item_name: "活動期間",
  singly_title_item_name: "タイトル",
  singly_twitter_account_item_name: "Twitterアカウント",
  singly_universities_item_name: "関連大学",
  singly_url_item_name: "HPのURL",
  singly_working_forms_item_name: "勤務形態",
  skill_name: "スキル",
  social_position: "現在のご職業",
  spread: "連携/拡散URL",
  st_simple_name: "提供サービス",
  status_name: "募集状況",
  stripe: {
    errors: {
      card_declined:
        "クレジットカードの決済が完了しませんでした。カードブランド、利用状況、またはその他の理由で問題が発生している可能性があります。お手数ですが、再度お試しいただくか、別のカードをご利用ください。",
      expired_card: "クレジットカードが有効期限切れです。",
      incorrect_cvc: "クレジットカードセキュリティコードが正しくありません。",
      incorrect_number: "クレジットカード番号が正しくありません。",
      incorrect_zip: "クレジットカードの請求先郵便番号が不正です。",
      insufficient_funds: "残高不足のため、カードを使用できません。",
      invalid_cvc: "クレジットカードセキュリティコードが不正です。",
      invalid_expiry_month: "クレジットカード有効期限月が不正です。",
      invalid_expiry_year: "クレジットカード有効期限年が不正です。",
      invalid_number: "クレジットカード番号が無効です。",
      missing: "クレジットカードが設定されていません。",
      payment_intent_authentication_failure:
        "カード認証に失敗しました。カード発行会社にお問い合わせください。",
      processing_error: "クレジットカード処理でエラーが発生しました。",
      rate_limit:
        "処理中にエラーが発生しました。エラーが続くようであればユーザーサポートにお知らせください。",
    },
  },
  tag_name: "社会問題",
  tour: "海外ツアー/プログラム",
  tour_activity_content_item_name: "活動内容",
  tour_activity_philosophy_item_name: "活動理念",
  tour_apply_link_item_name: "応募方法",
  tour_atmosphere_comment_item_name: "雰囲気",
  tour_atmospheres_item_name: "雰囲気",
  tour_build_year_item_name: "設立年",
  tour_characteristics_item_name: "特徴",
  tour_charitable_gifts_item_name: "物品の種類",
  tour_corporate_status_item_name: "法人格",
  tour_deadline_item_name: "募集締切",
  tour_description_item_name: "説明文",
  tour_detail_info_item_name: "募集詳細",
  tour_facebook_url_item_name: "FacebookページのURL",
  tour_genres_item_name: "活動テーマ",
  tour_get_activity_locations_item_name: "活動場所",
  tour_get_areas_item_name: "活動場所",
  tour_get_dates_or_terms_item_name: "活動日",
  tour_get_frequents_item_name: "活動頻度",
  tour_get_gender_rate_item_name: "男女比",
  tour_get_member_activity_dates_item_name: "活動日",
  tour_get_prices_item_name: "必要経費",
  tour_get_terms_and_frequents_item_name: "所属期間/頻度",
  tour_get_terms_or_periods_item_name: "活動期間",
  tour_get_working_forms_item_name: "勤務形態",
  tour_job_characteristics_item_name: "特徴",
  tour_job_types_item_name: "職種",
  tour_kind_item_name: "種類",
  tour_name_item_name: "団体名",
  tour_number_of_employees_item_name: "職員数",
  tour_participation_comment_item_name: "体験談",
  tour_participation_number_item_name: "募集人数",
  tour_pictures_item_name: "写真",
  tour_positions_item_name: "対象身分/年齢",
  tour_remarkable_points_item_name: "注目ポイント",
  tour_representation_item_name: "代表者",
  tour_service_types_item_name: "提供サービス",
  tour_skills_item_name: "スキル",
  tour_street_address_item_name: "住所",
  tour_tags_item_name: "社会問題",
  tour_target_item_name: "募集対象",
  tour_term_category_item_name: "活動期間",
  tour_title_item_name: "タイトル",
  tour_twitter_account_item_name: "Twitterアカウント",
  tour_universities_item_name: "関連大学",
  tour_url_item_name: "HPのURL",
  tour_working_forms_item_name: "勤務形態",
  trash: "ゴミ箱",
  wf_simple_name: "勤務形態",
  working_form_name: "勤務形態",
});
I18n.translations["ja"] = I18n.extend(I18n.translations["ja"] || {}, {
  activity_frequent_name: "頻度",
  activity_term_name: "期間",
  additional_email: "予備のメールアドレス",
  address: "住所",
  adopted: "採用済",
  all_contact_text: "伝達事項・質問",
  apply: "応募",
  area_name: "活動場所",
  area_simple_name: "エリア",
  ask: "お問い合わせ",
  atmosphere_name: "雰囲気",
  birthday: "生年月日",
  chara_simple_name: "特徴",
  characteristic_name: "特徴",
  closing: "募集終了",
  company_site: "連携企業",
  considering: "選考中",
  donate_goods: "物品寄付",
  donate_goods_activity_content_item_name: "活動内容",
  donate_goods_activity_philosophy_item_name: "活動理念",
  donate_goods_apply_link_item_name: "応募方法",
  donate_goods_atmosphere_comment_item_name: "雰囲気",
  donate_goods_atmospheres_item_name: "雰囲気",
  donate_goods_build_year_item_name: "設立年",
  donate_goods_characteristics_item_name: "特徴",
  donate_goods_charitable_gifts_item_name: "物品の種類",
  donate_goods_corporate_status_item_name: "法人格",
  donate_goods_deadline_item_name: "募集締切",
  donate_goods_description_item_name: "説明文",
  donate_goods_detail_info_item_name: "募集詳細",
  donate_goods_facebook_url_item_name: "FacebookページのURL",
  donate_goods_genres_item_name: "活動テーマ",
  donate_goods_get_activity_locations_item_name: "活動場所",
  donate_goods_get_areas_item_name: "活動場所",
  donate_goods_get_dates_or_terms_item_name: "活動日",
  donate_goods_get_frequents_item_name: "活動頻度",
  donate_goods_get_gender_rate_item_name: "男女比",
  donate_goods_get_member_activity_dates_item_name: "活動日",
  donate_goods_get_prices_item_name: "必要経費",
  donate_goods_get_terms_and_frequents_item_name: "所属期間/頻度",
  donate_goods_get_terms_or_periods_item_name: "所属期間",
  donate_goods_get_working_forms_item_name: "勤務形態",
  donate_goods_job_characteristics_item_name: "特徴",
  donate_goods_job_types_item_name: "職種",
  donate_goods_kind_item_name: "種類",
  donate_goods_name_item_name: "団体名",
  donate_goods_number_of_employees_item_name: "職員数",
  donate_goods_participation_comment_item_name: "体験談",
  donate_goods_participation_number_item_name: "募集人数",
  donate_goods_pictures_item_name: "写真",
  donate_goods_positions_item_name: "対象身分/年齢",
  donate_goods_remarkable_points_item_name: "注目ポイント",
  donate_goods_representation_item_name: "代表者",
  donate_goods_service_types_item_name: "提供サービス",
  donate_goods_skills_item_name: "スキル",
  donate_goods_street_address_item_name: "住所",
  donate_goods_tags_item_name: "社会問題",
  donate_goods_target_item_name: "募集対象",
  donate_goods_term_category_item_name: "活動期間",
  donate_goods_title_item_name: "タイトル",
  donate_goods_twitter_account_item_name: "Twitterアカウント",
  donate_goods_universities_item_name: "関連大学",
  donate_goods_url_item_name: "HPのURL",
  donate_goods_working_forms_item_name: "勤務形態",
  draft: "下書き",
  event: "イベント/講演会",
  event_activity_content_item_name: "活動内容",
  event_activity_philosophy_item_name: "活動理念",
  event_apply_link_item_name: "応募方法",
  event_atmosphere_comment_item_name: "雰囲気",
  event_atmospheres_item_name: "雰囲気",
  event_build_year_item_name: "設立年",
  event_characteristics_item_name: "特徴",
  event_charitable_gifts_item_name: "物品の種類",
  event_corporate_status_item_name: "法人格",
  event_deadline_item_name: "募集締切",
  event_description_item_name: "説明文",
  event_detail_info_item_name: "募集詳細",
  event_facebook_url_item_name: "FacebookページのURL",
  event_genres_item_name: "活動テーマ",
  event_get_activity_locations_item_name: "開催場所",
  event_get_areas_item_name: "開催場所",
  event_get_dates_or_terms_item_name: "開催日",
  event_get_frequents_item_name: "開催頻度",
  event_get_gender_rate_item_name: "男女比",
  event_get_member_activity_dates_item_name: "開催日",
  event_get_prices_item_name: "必要経費",
  event_get_terms_and_frequents_item_name: "所属期間/頻度",
  event_get_terms_or_periods_item_name: "活動期間",
  event_get_working_forms_item_name: "勤務形態",
  event_job_characteristics_item_name: "特徴",
  event_job_types_item_name: "職種",
  event_kind_item_name: "種類",
  event_name_item_name: "団体名",
  event_number_of_employees_item_name: "職員数",
  event_participation_comment_item_name: "体験談",
  event_participation_number_item_name: "募集人数",
  event_pictures_item_name: "写真",
  event_positions_item_name: "対象身分/年齢",
  event_remarkable_points_item_name: "注目ポイント",
  event_representation_item_name: "代表者",
  event_service_types_item_name: "提供サービス",
  event_skills_item_name: "スキル",
  event_street_address_item_name: "住所",
  event_tags_item_name: "社会問題",
  event_target_item_name: "募集対象",
  event_term_category_item_name: "開催期間",
  event_title_item_name: "タイトル",
  event_twitter_account_item_name: "Twitterアカウント",
  event_universities_item_name: "関連大学",
  event_url_item_name: "HPのURL",
  event_working_forms_item_name: "勤務形態",
  female: "女性",
  future: "公開予約",
  gender: "性別",
  genre_name: "活動テーマ",
  genre_simple_name: "テーマ",
  holding: "保留中",
  intern: "国内外インターンシップ",
  intern_activity_content_item_name: "活動内容",
  intern_activity_philosophy_item_name: "活動理念",
  intern_apply_link_item_name: "応募方法",
  intern_atmosphere_comment_item_name: "雰囲気",
  intern_atmospheres_item_name: "雰囲気",
  intern_build_year_item_name: "設立年",
  intern_characteristics_item_name: "特徴",
  intern_charitable_gifts_item_name: "物品の種類",
  intern_corporate_status_item_name: "法人格",
  intern_deadline_item_name: "募集締切",
  intern_description_item_name: "説明文",
  intern_detail_info_item_name: "募集詳細",
  intern_facebook_url_item_name: "FacebookページのURL",
  intern_genres_item_name: "活動テーマ",
  intern_get_activity_locations_item_name: "勤務場所",
  intern_get_areas_item_name: "勤務場所",
  intern_get_dates_or_terms_item_name: "勤務日",
  intern_get_frequents_item_name: "勤務頻度",
  intern_get_gender_rate_item_name: "男女比",
  intern_get_member_activity_dates_item_name: "勤務日",
  intern_get_prices_item_name: "待遇",
  intern_get_terms_and_frequents_item_name: "勤務期間/頻度",
  intern_get_terms_or_periods_item_name: "勤務期間",
  intern_get_working_forms_item_name: "勤務形態",
  intern_job_characteristics_item_name: "特徴",
  intern_job_types_item_name: "職種",
  intern_kind_item_name: "種類",
  intern_name_item_name: "団体名",
  intern_number_of_employees_item_name: "職員数",
  intern_participation_comment_item_name: "体験談",
  intern_participation_number_item_name: "募集人数",
  intern_pictures_item_name: "写真",
  intern_positions_item_name: "対象身分/年齢",
  intern_remarkable_points_item_name: "注目ポイント",
  intern_representation_item_name: "代表者",
  intern_service_types_item_name: "提供サービス",
  intern_skills_item_name: "スキル",
  intern_street_address_item_name: "住所",
  intern_tags_item_name: "社会問題",
  intern_target_item_name: "募集対象",
  intern_term_category_item_name: "勤務期間",
  intern_title_item_name: "タイトル",
  intern_twitter_account_item_name: "Twitterアカウント",
  intern_universities_item_name: "関連大学",
  intern_url_item_name: "HPのURL",
  intern_working_forms_item_name: "勤務形態",
  job: "社員/職員/アルバイト",
  job_activity_content_item_name: "活動内容",
  job_activity_philosophy_item_name: "活動理念",
  job_apply_link_item_name: "応募方法",
  job_area_name: "勤務地",
  job_atmosphere_comment_item_name: "雰囲気",
  job_atmospheres_item_name: "雰囲気",
  job_build_year_item_name: "設立年",
  job_chara_simple_name: "特徴",
  job_characteristic_name: "特徴",
  job_characteristics_item_name: "特徴",
  job_charitable_gifts_item_name: "物品の種類",
  job_corporate_status_item_name: "法人格",
  job_deadline_item_name: "募集締切",
  job_description_item_name: "説明文",
  job_detail_info_item_name: "募集詳細",
  job_facebook_url_item_name: "FacebookページのURL",
  job_genre_name: "活動テーマ",
  job_genres_item_name: "活動テーマ",
  job_get_activity_locations_item_name: "勤務場所",
  job_get_areas_item_name: "勤務場所",
  job_get_dates_or_terms_item_name: "勤務日",
  job_get_frequents_item_name: "勤務頻度",
  job_get_gender_rate_item_name: "男女比",
  job_get_member_activity_dates_item_name: "勤務日",
  job_get_prices_item_name: "待遇",
  job_get_terms_and_frequents_item_name: "勤務期間/頻度",
  job_get_terms_or_periods_item_name: "勤務期間",
  job_get_working_forms_item_name: "勤務形態",
  job_job_characteristics_item_name: "特徴",
  job_job_type_name: "職種",
  job_job_types_item_name: "職種",
  job_kind_item_name: "種類",
  job_name_item_name: "団体名",
  job_number_of_employees_item_name: "職員数",
  job_participation_comment_item_name: "体験談",
  job_participation_number_item_name: "募集人数",
  job_pictures_item_name: "写真",
  job_position_name: "対象年齢/身分",
  job_positions_item_name: "対象身分/年齢",
  job_remarkable_points_item_name: "注目ポイント",
  job_representation_item_name: "代表者",
  job_service_type_name: "提供サービス",
  job_service_types_item_name: "提供サービス",
  job_skills_item_name: "スキル",
  job_street_address_item_name: "住所",
  job_tag_name: "社会問題",
  job_tags_item_name: "社会問題",
  job_target_item_name: "募集対象",
  job_term_category_item_name: "勤務期間",
  job_title_item_name: "タイトル",
  job_twitter_account_item_name: "Twitterアカウント",
  job_type_name: "職種",
  job_universities_item_name: "関連大学",
  job_url_item_name: "HPのURL",
  job_working_form_name: "勤務形態",
  job_working_forms_item_name: "勤務形態",
  jt_simple_name: "職種",
  kind_name: "種類",
  kind_simple_name: "種類",
  male: "男性",
  member: "団体メンバー/継続ボランティア",
  member_activity_content_item_name: "活動内容",
  member_activity_philosophy_item_name: "活動理念",
  member_apply_link_item_name: "応募方法",
  member_atmosphere_comment_item_name: "雰囲気",
  member_atmospheres_item_name: "雰囲気",
  member_build_year_item_name: "設立年",
  member_characteristics_item_name: "特徴",
  member_charitable_gifts_item_name: "物品の種類",
  member_corporate_status_item_name: "法人格",
  member_deadline_item_name: "募集締切",
  member_description_item_name: "説明文",
  member_detail_info_item_name: "募集詳細",
  member_facebook_url_item_name: "FacebookページのURL",
  member_genres_item_name: "活動テーマ",
  member_get_activity_locations_item_name: "活動場所",
  member_get_areas_item_name: "活動場所",
  member_get_dates_or_terms_item_name: "活動日",
  member_get_frequents_item_name: "活動頻度",
  member_get_gender_rate_item_name: "男女比",
  member_get_member_activity_dates_item_name: "活動日",
  member_get_prices_item_name: "必要経費",
  member_get_terms_and_frequents_item_name: "所属期間/頻度",
  member_get_terms_or_periods_item_name: "所属期間",
  member_get_working_forms_item_name: "勤務形態",
  member_job_characteristics_item_name: "特徴",
  member_job_types_item_name: "職種",
  member_kind_item_name: "種類",
  member_name_item_name: "団体名",
  member_number_of_employees_item_name: "職員数",
  member_participation_comment_item_name: "体験談",
  member_participation_number_item_name: "募集人数",
  member_pictures_item_name: "写真",
  member_positions_item_name: "対象身分/年齢",
  member_remarkable_points_item_name: "注目ポイント",
  member_representation_item_name: "代表者",
  member_service_types_item_name: "提供サービス",
  member_skills_item_name: "スキル",
  member_street_address_item_name: "住所",
  member_tags_item_name: "社会問題",
  member_target_item_name: "募集対象",
  member_term_category_item_name: "活動期間",
  member_title_item_name: "タイトル",
  member_twitter_account_item_name: "Twitterアカウント",
  member_universities_item_name: "関連大学",
  member_url_item_name: "HPのURL",
  member_working_forms_item_name: "勤務形態",
  no_answer: "回答しない",
  not_set: "未対応",
  organic: "activo",
  overlapping: "重複応募",
  part_timer: "バイト/パート",
  phone_num: "電話番号",
  posi_simple_name: "対象年齢/身分",
  position_name: "対象年齢/身分",
  postal_code: "郵便番号",
  price_category_name: "予算",
  probono: "プロボノ",
  probono_activity_content_item_name: "活動内容",
  probono_activity_philosophy_item_name: "活動理念",
  probono_apply_link_item_name: "応募方法",
  probono_atmosphere_comment_item_name: "雰囲気",
  probono_atmospheres_item_name: "雰囲気",
  probono_build_year_item_name: "設立年",
  probono_characteristics_item_name: "特徴",
  probono_charitable_gifts_item_name: "物品の種類",
  probono_corporate_status_item_name: "法人格",
  probono_deadline_item_name: "募集締切",
  probono_description_item_name: "説明文",
  probono_detail_info_item_name: "募集詳細",
  probono_facebook_url_item_name: "FacebookページのURL",
  probono_genres_item_name: "活動テーマ",
  probono_get_activity_locations_item_name: "活動場所",
  probono_get_areas_item_name: "活動場所",
  probono_get_dates_or_terms_item_name: "活動日",
  probono_get_frequents_item_name: "活動頻度",
  probono_get_gender_rate_item_name: "男女比",
  probono_get_member_activity_dates_item_name: "活動日",
  probono_get_prices_item_name: "必要経費",
  probono_get_terms_and_frequents_item_name: "所属期間/頻度",
  probono_get_terms_or_periods_item_name: "活動期間",
  probono_get_working_forms_item_name: "勤務形態",
  probono_job_characteristics_item_name: "特徴",
  probono_job_types_item_name: "職種",
  probono_kind_item_name: "種類",
  probono_name_item_name: "団体名",
  probono_number_of_employees_item_name: "職員数",
  probono_participation_comment_item_name: "体験談",
  probono_participation_number_item_name: "募集人数",
  probono_pictures_item_name: "写真",
  probono_positions_item_name: "対象身分/年齢",
  probono_remarkable_points_item_name: "注目ポイント",
  probono_representation_item_name: "代表者",
  probono_service_types_item_name: "提供サービス",
  probono_skills_item_name: "スキル",
  probono_street_address_item_name: "住所",
  probono_tags_item_name: "社会問題",
  probono_target_item_name: "募集対象",
  probono_term_category_item_name: "活動期間",
  probono_title_item_name: "タイトル",
  probono_twitter_account_item_name: "Twitterアカウント",
  probono_universities_item_name: "関連大学",
  probono_url_item_name: "HPのURL",
  probono_working_forms_item_name: "勤務形態",
  promotion: "広報力upオプション",
  publish: "募集中",
  regular_employee: "社員/職員",
  rejected: "不採用",
  replied: "返信済み",
  scout: "スカウト",
  search_for_company: "連携企業",
  singly: "国内/単発ボランティア",
  singly_activity_content_item_name: "活動内容",
  singly_activity_philosophy_item_name: "活動理念",
  singly_apply_link_item_name: "応募方法",
  singly_atmosphere_comment_item_name: "雰囲気",
  singly_atmospheres_item_name: "雰囲気",
  singly_build_year_item_name: "設立年",
  singly_characteristics_item_name: "特徴",
  singly_charitable_gifts_item_name: "物品の種類",
  singly_corporate_status_item_name: "法人格",
  singly_deadline_item_name: "募集締切",
  singly_description_item_name: "説明文",
  singly_detail_info_item_name: "募集詳細",
  singly_facebook_url_item_name: "FacebookページのURL",
  singly_genres_item_name: "活動テーマ",
  singly_get_activity_locations_item_name: "活動場所",
  singly_get_areas_item_name: "活動場所",
  singly_get_dates_or_terms_item_name: "活動日",
  singly_get_frequents_item_name: "活動頻度",
  singly_get_gender_rate_item_name: "男女比",
  singly_get_member_activity_dates_item_name: "活動日",
  singly_get_prices_item_name: "必要経費",
  singly_get_terms_and_frequents_item_name: "所属期間/頻度",
  singly_get_terms_or_periods_item_name: "活動期間",
  singly_get_working_forms_item_name: "勤務形態",
  singly_job_characteristics_item_name: "特徴",
  singly_job_types_item_name: "職種",
  singly_kind_item_name: "種類",
  singly_name_item_name: "団体名",
  singly_number_of_employees_item_name: "職員数",
  singly_participation_comment_item_name: "体験談",
  singly_participation_number_item_name: "募集人数",
  singly_pictures_item_name: "写真",
  singly_positions_item_name: "対象身分/年齢",
  singly_remarkable_points_item_name: "注目ポイント",
  singly_representation_item_name: "代表者",
  singly_service_types_item_name: "提供サービス",
  singly_skills_item_name: "スキル",
  singly_street_address_item_name: "住所",
  singly_tags_item_name: "社会問題",
  singly_target_item_name: "募集対象",
  singly_term_category_item_name: "活動期間",
  singly_title_item_name: "タイトル",
  singly_twitter_account_item_name: "Twitterアカウント",
  singly_universities_item_name: "関連大学",
  singly_url_item_name: "HPのURL",
  singly_working_forms_item_name: "勤務形態",
  skill_name: "スキル",
  social_position: "現在のご職業",
  spread: "連携/拡散URL",
  st_simple_name: "提供サービス",
  status_name: "募集状況",
  stripe: {
    errors: {
      card_declined:
        "クレジットカードの決済が完了しませんでした。カードブランド、利用状況、またはその他の理由で問題が発生している可能性があります。お手数ですが、再度お試しいただくか、別のカードをご利用ください。",
      expired_card: "クレジットカードが有効期限切れです。",
      incorrect_cvc: "クレジットカードセキュリティコードが正しくありません。",
      incorrect_number: "クレジットカード番号が正しくありません。",
      incorrect_zip: "クレジットカードの請求先郵便番号が不正です。",
      insufficient_funds: "残高不足のため、カードを使用できません。",
      invalid_cvc: "クレジットカードセキュリティコードが不正です。",
      invalid_expiry_month: "クレジットカード有効期限月が不正です。",
      invalid_expiry_year: "クレジットカード有効期限年が不正です。",
      invalid_number: "クレジットカード番号が無効です。",
      missing: "クレジットカードが設定されていません。",
      payment_intent_authentication_failure:
        "カード認証に失敗しました。カード発行会社にお問い合わせください。",
      processing_error: "クレジットカード処理でエラーが発生しました。",
      rate_limit:
        "処理中にエラーが発生しました。エラーが続くようであればユーザーサポートにお知らせください。",
    },
  },
  tag_name: "社会問題",
  tour: "海外ツアー/プログラム",
  tour_activity_content_item_name: "活動内容",
  tour_activity_philosophy_item_name: "活動理念",
  tour_apply_link_item_name: "応募方法",
  tour_atmosphere_comment_item_name: "雰囲気",
  tour_atmospheres_item_name: "雰囲気",
  tour_build_year_item_name: "設立年",
  tour_characteristics_item_name: "特徴",
  tour_charitable_gifts_item_name: "物品の種類",
  tour_corporate_status_item_name: "法人格",
  tour_deadline_item_name: "募集締切",
  tour_description_item_name: "説明文",
  tour_detail_info_item_name: "募集詳細",
  tour_facebook_url_item_name: "FacebookページのURL",
  tour_genres_item_name: "活動テーマ",
  tour_get_activity_locations_item_name: "活動場所",
  tour_get_areas_item_name: "活動場所",
  tour_get_dates_or_terms_item_name: "活動日",
  tour_get_frequents_item_name: "活動頻度",
  tour_get_gender_rate_item_name: "男女比",
  tour_get_member_activity_dates_item_name: "活動日",
  tour_get_prices_item_name: "必要経費",
  tour_get_terms_and_frequents_item_name: "所属期間/頻度",
  tour_get_terms_or_periods_item_name: "活動期間",
  tour_get_working_forms_item_name: "勤務形態",
  tour_job_characteristics_item_name: "特徴",
  tour_job_types_item_name: "職種",
  tour_kind_item_name: "種類",
  tour_name_item_name: "団体名",
  tour_number_of_employees_item_name: "職員数",
  tour_participation_comment_item_name: "体験談",
  tour_participation_number_item_name: "募集人数",
  tour_pictures_item_name: "写真",
  tour_positions_item_name: "対象身分/年齢",
  tour_remarkable_points_item_name: "注目ポイント",
  tour_representation_item_name: "代表者",
  tour_service_types_item_name: "提供サービス",
  tour_skills_item_name: "スキル",
  tour_street_address_item_name: "住所",
  tour_tags_item_name: "社会問題",
  tour_target_item_name: "募集対象",
  tour_term_category_item_name: "活動期間",
  tour_title_item_name: "タイトル",
  tour_twitter_account_item_name: "Twitterアカウント",
  tour_universities_item_name: "関連大学",
  tour_url_item_name: "HPのURL",
  tour_working_forms_item_name: "勤務形態",
  trash: "ゴミ箱",
  wf_simple_name: "勤務形態",
  working_form_name: "勤務形態",
});
// NOTE: (恐らく他のネームスペースと競合することで)otherをコメントインすると正常にja.jsが正常されなくなるため、
// バックエンドから取得するのではなく、このファイルでハードコードして翻訳を定義している。
I18n.translations["ja"]["other"] = "その他";
export default I18n;
